var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8541 15.833C19.1923 14.2621 20 12.2254 20 10C20 5.02944 15.9706 1 11 1C6.02944 1 2 5.02944 2 10C2 14.9706 6.02944 19 11 19C12.7611 19 14.404 18.4942 15.7914 17.6199L19.8071 21.6362C20.2624 22.0915 21.0625 22.0299 21.594 21.4984C22.1256 20.9669 22.1873 20.1668 21.732 19.7114L17.8541 15.833ZM18 10C18 13.866 14.866 17 11 17C7.13401 17 4 13.866 4 10C4 6.13401 7.13401 3 11 3C14.866 3 18 6.13401 18 10ZM7 10C7 9.44771 7.44772 9 8 9H10V7C10 6.44772 10.4477 6 11 6C11.5523 6 12 6.44772 12 7V9H14C14.5523 9 15 9.44771 15 10C15 10.5523 14.5523 11 14 11H12V13C12 13.5523 11.5523 14 11 14C10.4477 14 10 13.5523 10 13V11H8C7.44772 11 7 10.5523 7 10Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/ZoomIn.19046fa8f323480e73fb32bdf8fa52be.svg";
export { ForwardRef as ReactComponent };